import React, { useCallback, useContext, useState } from 'react'
import { Modal, Button, Form, Col, Row } from '@themesberg/react-bootstrap'
import { Context } from '../..'
import { useCookies } from 'react-cookie';
import { upload } from '../../controller';

const _Popup = () => {

  const { state, dispatch } = useContext(Context);

  const [cookies] = useCookies(['wvivu'])

  const [image, setImage] = useState(undefined);

  const handleClose = useCallback(() => {
    dispatch({
      type: 'CLOSE_CONFIRM_POPUP',
      payload: {
        confirmed: false,
      },
    })
  }, [])

  const handleConfirm = useCallback(() => {
    if (image) {
      dispatch({
        type: 'CLOSE_CONFIRM_POPUP',
        payload: {
          confirmed: true,
          image: image,
        },
      })
      setImage(undefined)
    } else {
      alert('Hãy up file vé')
    }
  }, [image])

  const uploadFunc = useCallback(async (file) => {

    const response = await upload(state.confirmPopup.id, 'ticket', file)
    setImage(response)
  }, [
    state.confirmPopup.id
  ])

  const onImageChange = (evt) => {
    if (evt.target.files[0]) {
      uploadFunc(evt.target.files[0])
    }
  }

  return (
    <Modal as={Modal.Dialog} centered show={state.confirmPopup.show} onHide={(handleClose)}>
      <Modal.Header>
        <Modal.Title className="h6">Xuất vé nhanh</Modal.Title>
        <Button variant="close" aria-label="Close" onClick={handleClose} />
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Row>
            <Col md={12} className="mb-2">
              <Form.Group id="firstName">
                <Form.Label>Vé vật lý</Form.Label>
                <Form.Control required type="file" onChange={onImageChange} />
              </Form.Group>
            </Col>
          </Row>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        {image ? 'Xong' : ''}
        <Button variant="secondary" className="ms-auto" onClick={handleConfirm}>
          Xác nhận
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default React.memo(_Popup)